import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";

import { useAppTrue } from "hooks";
import { Auth0Provider } from "@auth0/auth0-react";
import { AppWrapper } from "@pagegrowler_nextjs";

export const FullApp = ({ pageProps, Component }) => {
  const isApp = useAppTrue();
  
  if (process.env.NEXT_PUBLIC_APP_ENV === "devel") {
    return (
      <div style={{ marginTop: isApp ? "30px" : "0px" }}>
        <AppWrapper>
          <Component {...pageProps} />
        </AppWrapper>
      </div>
    );
  }
  return (
    <Auth0Provider
      domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN}
      clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      audience={process.env.NEXT_PUBLIC_AUTH0_AUDIENCE}
      useRefreshTokensFallback={true}
      authorizationParams={{
        redirect_uri: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/login`,
        issuer: process.env.NEXT_PUBLIC_AUTH0_ISSUER,
        audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE,
        scope: "openid email profile offline_access",
      }}
    >
      <div style={{ marginTop: isApp ? "30px" : "0px" }}>
        <AppWrapper>
          <Component {...pageProps} />
        </AppWrapper>
      </div>
    </Auth0Provider>
  );
};
